<!--when CSC account logged in this page will be read only--- isCSR-->
<div class="headerSection">
  <div class="row">
    <div class="col-sm-12">
      <p style="color:red;">The business owner of any Kawneer customer is responsible and liable for use of the Kawneer Direct Website through the access it provides to its employees, contractors or otherwise, directly or indirectly.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="row" *ngIf="isMultiCustomerAccount || isCSR">
        <div class="col-sm-10">
          <kendo-combobox class="customerTxt"
                          [data]="filteredCustomerItems"
                          [textField]="'customerNameToDisplay'"
                          [filterable]="true"
                          [valueField]="'customerNumber'"
                          (selectionChange)="customerChangeSelected($event)"
                          (close)="onCloseCustomerChange($event)"
                          (filterChange)="handleCustomerFilter($event)"
                          [placeholder]="'Please type a Customer Name or Number to search'">
          </kendo-combobox>
          <!--<kendo-autocomplete class="col customerTxt" #customerName name="customerName"
                              [data]="filteredCustomerItems "
                              [(ngModel)]="selectedCustomer"
                              [valueField]="'fullCustomer'"
                              placeholder="Please type a customer name"
                              [virtual]="true"
                              [filterable]="true"
                              [highlightFirst]="false"
                              (filterChange)="handleCustomerFilter($event)"
                              [loading]="customerSearchLoading | async">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>

              <ng-container *ngFor="let substring of splitText(dataItem.fullCustomer)">
                <ng-container *ngIf="substring.toLowerCase() === currentInputValueInItemSearch.toLowerCase();
            else boldTemplateName
          ">
                  <span>{{ substring }}</span>
                </ng-container>
                <ng-template #boldTemplateName>
                  <b>{{ substring }}</b>
                </ng-template>
              </ng-container>
            </ng-template>

            <ng-template kendoAutoCompleteNoDataTemplate>
              <div *ngIf="showSuggestionBox">
                <h4>
                  <span class="k-icon k-i-warning"></span>
                  <br /><br />
                  No items match
                  <br />
                  "{{ currentInputValueInItemSearch }}"
                </h4>
              </div>
            </ng-template>
          </kendo-autocomplete>-->
        </div>
        <div class="col-sm-2 buttonLeft">
          <button class="m-3 clearKendoButton btn btn-success" kendoButton (click)="updateCustomer()">
            Change Customer
          </button>
        </div>

      </div>
      <p>
        ACCOUNT #{{currentCustomer?.customerNumber}}<br />
        {{currentCustomer?.customerNumber}} - {{currentCustomer?.customerName}} <br>
        {{currentCustomer?.addressLine1}} <br />
        {{currentCustomer?.city}}, {{currentCustomer?.state}} {{currentCustomer?.zipCode}}
      </p>
    </div>
    <div class="col-sm-6">
    </div>
  </div>
</div>

<br />
<section>

  <kendo-grid [data]="manageAccountGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="accountGridstate.sort"
              (sortChange)="manageAccountGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="accountGridstate.take"
              [skip]="accountGridstate.skip"
              [columnMenu]="false"
              (pageChange)="manageAccountGridPageChange($event)"
              (dataStateChange)="manageAccountDataStateChange($event)"
              [filter]="accountGridstate.filter"
              [loading]="gridSettings.gridLoading">

    <kendo-grid-column field="userName" title="{{manageAccountsGridColumnLbl.userId}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false" [width]="70">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">{{manageAccountsGridColumnLbl.userId}}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="userFirstName" title="{{manageAccountsGridColumnLbl.firstName}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false" [width]="75">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">{{manageAccountsGridColumnLbl.firstName}}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="userLastName" title="{{manageAccountsGridColumnLbl.lastName}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false" [width]="75">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">{{manageAccountsGridColumnLbl.lastName}}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="email" title="{{manageAccountsGridColumnLbl.email}}" [width]="75" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">{{manageAccountsGridColumnLbl.email}}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="userPhoneNumber" title="{{manageAccountsGridColumnLbl.phoneNumber}}" [width]="75" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">{{manageAccountsGridColumnLbl.phoneNumber}}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="hasInvoiceInquiry" title="{{manageAccountsGridColumnLbl.invoiceInquiry}}" [filterable]="false"   [width]="60">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">
          Invoice<br />Inquiry
          <span class="k-icon k-i-info" title="Allows user to see invoices online."></span>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.hasInvoiceInquiry" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="isCSR">
        </kendo-switch>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="customerCurrencyCode!='CAD'" field="hasUserManagePaymentsACH" title="{{manageAccountsGridColumnLbl.hasAchPayment}}" [filterable]="false"   [width]="60">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">
          ACH <br/>Payment
          <span class="k-icon k-i-info" title="Allows US user to process online payments. Not available for CAD"></span>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.hasUserManagePaymentsACH" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="isCSR">
        </kendo-switch>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="hasAccountSummary" title="{{manageAccountsGridColumnLbl.accountSummary}}" [filterable]="false"  [width]="70">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">
          Account<br/>Summary
          <span class="k-icon k-i-info" title="Allows user to access the Account Summary page containing credit limit, balance due, etc."></span>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.hasAccountSummary" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="isCSR">
        </kendo-switch>
      </ng-template>
    </kendo-grid-column>
    <!--<kendo-grid-column field="hasManageAddress" title="{{manageAccountsGridColumnLbl.manageAddress}}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (click)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.hasManageAddress" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="isCSR">
        </kendo-switch>
      </ng-template>
    </kendo-grid-column>-->

  <kendo-grid-command-column title="{{manageAccountsGridColumnLbl.placeOrder}}" field="canPlaceOrder" [width]="60">
    <ng-template kendoGridHeaderTemplate let-column>
      <div style="font-size:10px;">
        Can Place<br />Order
        <span class="k-icon k-i-info" title="Allows user to submit product orders for processing."></span>
      </div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.canPlaceOrder" [onLabel]="'Yes'"
                    [offLabel]="'No'" [disabled]="isCSR">
      </kendo-switch>
    </ng-template>
  </kendo-grid-command-column>

  <kendo-grid-column field="hasUserAccountManager" title="{{manageAccountsGridColumnLbl.manageUsersLbl}}" [columnMenu]="false" [width]="60"
                     [filterable]="false" [editable]="false">
    <ng-template kendoGridHeaderTemplate let-column>
      <div style="font-size:10px;">
       Manage<br/> User
        <span class="k-icon k-i-info" title="Allows user to add and edit users and permissions"></span>
      </div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.hasUserAccountManager" [onLabel]="'Yes'"
                    [offLabel]="'No'" [disabled]="isCSR">
      </kendo-switch>
    </ng-template>
  </kendo-grid-column>
    <!--Need to implement active in-active functionality-->
    <kendo-grid-command-column title="Active" field="isActive" [width]="60">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="font-size:10px;">
          Active
          <span class="k-icon k-i-info" title="Makes user active or inactive. Inactive accounts are unable to login or view quotes/orders and will be permanently removed after 210 days of inactivity."></span>
        </div>
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (valueChange)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="isCSR">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>

    <!-- <kendo-grid-column field="lastLogin" title="{{manageAccountsGridColumnLbl.lastLogin}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>-->
  <kendo-grid-command-column title="Actions" [width]="135" field="">
    <ng-template kendoGridHeaderTemplate let-column>
      <div style="font-size:10px;">Actions</div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <button kendoButton class="btn btn-success"
              (click)="toggleEditUserDialog(dataItem)" [disabled]="isCSR">
        <span class=" k-icon k-i-edit k-i-pencil"></span>
      </button><span class="k-icon k-i-info" title="Change user’s name and contact information."></span><br />
      <button kendoButton class="btn btn-success"
              (click)="toggleResetPwdUserDialog(dataItem)" [disabled]="isCSR">
        {{this.resetPwdUserDialog.title}}
      </button>
      <span class="k-icon k-i-info" title="Sends temporary password to assist user in logging in."></span>
    </ng-template>
  </kendo-grid-command-column>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" *ngIf="!isCSR">
    <button (click)="toggleNewUserDialog()" [icon]="'plus'" class="m-3 clearKendoButton btn btn-success" kendoButton>
      Add New User
    </button>
  </div>
</section>
<section>
  <kendo-dialog title="Add New User" *ngIf="newUserDialog.opened" (close)="toggleNewUserDialog()">
    <div class="newUserDiv">
      <form [formGroup]="addNewUserForm" autocomplete="off">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label class="lblCls">
                {{newUserDialog.userIdLabel}}<span class="requiredField">*</span>
              </label>
              <div class="input-wrapper">
                <kendo-textbox class="form-control" formControlName="userName"
                               [ngClass]="{'borderRed':newUserDialog.isEmptyUserName ||newUserDialog.showUserNameIcon}" (keydown)="keyDownHandler($event)"
                               (blur)="checkUserNameExist()"></kendo-textbox>
                <span class="k-icon k-i-loading" *ngIf="newUserDialog.userNameProcessing"></span>
                <span id="icon_move" class="k-icon k-i-check-circle k-i-checkmark-circle spanInfoIconCls"
                      *ngIf="newUserDialog.isUserNameValid"
                      style="color:green;font-weight:600"></span>
                <span [title]="newUserDialog.userNameErrorTitle" *ngIf="newUserDialog.showUserNameIcon" kendoTooltip
                      class="k-icon k-i-information k-i-info spanInfoIconCls" style="margin-left: -6px;"></span>
              </div>
              </div>
              <div class="form-group">
                <label class="lblCls">
                  {{newUserDialog.userLanguageLabel}}<span class="requiredField">*</span>
                </label>
                <kendo-dropdownlist class="kendoInput" name="userLanguage"
                                    formControlName="userLanguage"
                                    [data]="getAllLanguages"
                                    [textField]="'userLanguage'"
                                    [valueField]="'userLanguage'"
                                    [valuePrimitive]="true"
                                    [ngClass]="{'borderRed':newUserDialog.isEmptyLanguage && newUserDialog.isSubmitted}"
                                    (blur)="validateNewUserForm()">
                </kendo-dropdownlist>
              </div>
              <div class="form-group">
                <label class="lblCls">
                  {{newUserDialog.firstNamelabel}}<span class="requiredField">*</span>
                </label>
                <kendo-textbox class="form-control" formControlName="firstName"
                               [ngClass]="{'borderRed':newUserDialog.isInvalidFirstName && newUserDialog.isSubmitted}"
                               (blur)="validateNewUserForm()"></kendo-textbox>
              </div>

              <div class="form-group">
                <label class="lblCls">
                  {{newUserDialog.lastNameLabel}}<span class="requiredField">*</span>
                </label>
                <kendo-textbox class="form-control" formControlName="lastName"
                               [ngClass]="{'borderRed':newUserDialog.isInvalidLastName && newUserDialog.isSubmitted}" (blur)="validateNewUserForm()"></kendo-textbox>
              </div>

              <!--<div class="form-group">
    <label class="lblCls">
      {{newUserDialog.companyNameLabel}}
    </label>
    <kendo-textbox class="form-control" formControlName="companyName"
                   [ngClass]="{'borderRed':newUserDialog.isInvalidCompanyName && newUserDialog.isSubmitted}"
                   (blur)="validateNewUserForm()"></kendo-textbox>
  </div>-->
              <!--<div class="form-group">
    <label class="lblCls">
      {{newUserDialog.companyAccNumberLabel}}
    </label>
    <kendo-textbox class="form-control" formControlName="companyAccNumber"
                   [ngClass]="{'borderRed':newUserDialog.isInvalidCompanyAccNumber && newUserDialog.isSubmitted}"
                   (blur)="validateNewUserForm()"></kendo-textbox>
  </div>-->
            </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label class="lblCls">
                {{newUserDialog.phoneNumberLabel}}<span class="requiredField">*</span>
              </label>
              <kendo-numerictextbox class="kendoInput" name="phoneNumber" formControlName="phoneNumber" [decimals]="0"
                                    [format]="'#'" [spinners]="false"
                                    [ngClass]="{'borderRed':newUserDialog.isInvalidPhoneNumber && newUserDialog.isSubmitted}"
                                    maxlength="10" (blur)="validateNewUserForm()"></kendo-numerictextbox>
              <span title="Phone number length should be minimum 10"
                    *ngIf="newUserDialog.isInvalidPhoneNumberMessage" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
            <div class="form-group">
              <label class="lblCls">
                {{newUserDialog.emailLabel}}<span class="requiredField">*</span>
              </label>
              <div class="input-wrapper">
                <kendo-textbox class="form-control" formControlName="email"
                               [ngClass]="{'borderRed':newUserDialog.isInvalidEmail}"
                               (blur)="emailLeave()"></kendo-textbox>
                <span title="{{newUserDialog.invalidEmail}}" *ngIf="newUserDialog.isEmailFormatInValid" kendoTooltip
                      class="k-icon k-i-information k-i-info spanInfoIconCls" style="margin-left:-5.5px"></span>
                </div>
              </div>
            <div class="form-group">
              <label class="lblCls">
                {{newUserDialog.confirmEmailLabel}}<span class="requiredField">*</span>
              </label>
              <div class="input-wrapper">
                <kendo-textbox class="form-control" formControlName="confirmEmail"
                               [ngClass]="{'borderRed':newUserDialog.isInvalidConfirmEmail}"
                               (blur)="confirmEmailLeave()"></kendo-textbox>
                <span title="{{newUserDialog.confirmEmailMatch}}" *ngIf="newUserDialog.isEmailNotMatched" kendoTooltip style="margin-left:-5.5px"
                      class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
              </div>
              </div>
            </div>
        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                        (click)="registerUser()">
                  Register<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
                <button kendoButton [disabled]=" saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                        (click)="resetUserForm()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </kendo-dialog>
</section>

<section class="dialogSection">
  <kendo-dialog title="Edit User" *ngIf="editUserDialog.opened" (close)="toggleEditUserDialog()">
    <form [formGroup]="editUserForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lblCls">
              {{editUserDialog.userNameLabel}}
            </label>
            <kendo-textbox [readonly]="true" class="form-control" formControlName="userName" [ngStyle]="{'pointer-events': 'none','opacity': '0.6'}"
                           [ngClass]="{'borderRed':editUserDialog.isEmptyUserName || editUserDialog.showUserNameIcon}"
                           (blur)="checkUserNameExistInUpdate()" disabled></kendo-textbox>
            <span title="Username is not available" *ngIf="editUserDialog.showUserNameIcon" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            <span class="k-icon k-i-loading" *ngIf="editUserDialog.userNameProcessing"></span>
            <span class="k-icon k-i-check-circle k-i-checkmark-circle spanInfoIconCls"
                  *ngIf="editUserDialog.isUserNameValid"
                  style="color:green;font-weight:600"></span>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{editUserDialog.firstNamelabel}}
            </label>
            <kendo-textbox class="form-control" formControlName="firstName"
                           [ngClass]="{'borderRed':editUserDialog.isInvalidFirstName && editUserDialog.isSubmitted}"
                           (blur)="validateEditUserForm()"></kendo-textbox>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{editUserDialog.lastNameLabel}}
            </label>
            <kendo-textbox class="form-control" formControlName="lastName"
                           [ngClass]="{'borderRed':editUserDialog.isInvalidLastName && editUserDialog.isSubmitted}"
                           (blur)="validateEditUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{editUserDialog.emailLabel}}
            </label>
            <kendo-textbox class="form-control" formControlName="email"
                           [ngClass]="{'borderRed':editUserDialog.isInvalidEmail}"
                           (blur)="editUserEmailLeave()"></kendo-textbox>
            <span title="{{newUserDialog.invalidEmail}}" *ngIf="editUserDialog.isEmailFormatInValid" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
          <!--<div class="form-group">
            <label class="lblCls">
              {{editUserDialog.passwordLabel}}
            </label>
            <kendo-textbox class="form-control" formControlName="password"
                           [ngClass]="{'borderRed':editUserDialog.isInvalidPassword && editUserDialog.isSubmitted}"
                           (blur)="validateEditUserForm()"></kendo-textbox>
          </div>-->
          <input type="hidden" formControlName="isInvoiceInquiry" />
          <input type="hidden" formControlName="isAccountSummary" />
          <input type="hidden" formControlName="isManageAddress" />
          <input type="hidden" formControlName="canPlaceOrder" />
        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleEditUserDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="updateUser()">
                Update<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>

<section class="dialogSection">
  <kendo-dialog title="{{this.resetPwdUserDialog.title}}" *ngIf="resetPwdUserDialog.opened" (close)="toggleResetPwdUserDialog()">
    <form [formGroup]="editUserForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lblCls">
              {{this.resetPwdUserDialog.msg}}
            </label>
         </div>
          </div>
        </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleResetPwdUserDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="resetPwd()">
                {{this.resetPwdUserDialog.title}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
